import React, { useEffect } from 'react';
import { Modal, Box, Typography, Fade } from '@mui/material';
import { useDispatch } from 'react-redux';
import { setShowWelcomeModal } from './authSlice';

const WelcomeModal = ({ open, username }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        dispatch(setShowWelcomeModal(false));
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [open, dispatch]);

  return (
    <Modal
      open={open}
      closeAfterTransition
      aria-labelledby="welcome-modal-title"
    >
      <Fade in={open}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
            textAlign: 'center'
          }}
        >
          <Typography id="welcome-modal-title" variant="h5" component="h2" gutterBottom>
            ようこそ！
          </Typography>
          <Typography variant="body1">
            {username}さん、ClachSyncへようこそ！
          </Typography>
        </Box>
      </Fade>
    </Modal>
  );
};

export default WelcomeModal;
